// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/fonts/AlteHaasGroteskBold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  overflow: hidden;
}

.main_display {
  display : flex;
  /* height: -webkit-fill-available; */
  height : 97vh;
  background-color: #395e65;
  overflow: hidden;
}

.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

.main_page_frame {
    display: -webkit-inline-box;
    height: 100%;
    width: 100%;
    border : 0;
}

.logo_display {
  display : flex;
  cursor : help;
  width : 500%;
  height : 500%;
}

.image_display {
  width : 100px;;
  height : 115px;;
}

.main_page_index {
  background-color: #395e65;
  width : 85%;
  align : "center";
}

.main_page_index.mobile {
  width : 65%;
}

.App {
  text-align: center;
  flex : 1 1;
  overflow: hidden;
}



.app_panel {
  overflow: hidden;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

@font-face {
  font-family: alte_haas_grotesk ;
  src:url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

* {
  font-family: alte_haas_grotesk;
}

.chat-container {
  display: flex;
  flex-direction: column;
  height: 90vh; 
  overflow-y: hidden;
}

.chat-menus {
  display : flex;
  flex-direction: row;
  height: 11%; 
}


.chat-header {
  display: flex;
  width : 47%;
  gap : 10px;
  flex-direction: row;
  height : 10%;
}
.chat-double-panel {
  display : flex;
  width : 98%;
  gap : 1x;
  height : 91%;
  overflow-y: hidden;
}

.split-handle {
  background-color: #fff066;
  cursor: col-resize;
  position: relative;
  border-radius: 10px;
  }

.split-handle:hover,
.split-handle:active {
  background-color: #83ddef;
}

.graphContainer {
  width: 165%;
  height: 62%; 
}

.semantic_panel {
  overflow-y : hidden;
}


.graphContainer.mobile {
  width: 130%;
  height: 200%; 
}

.qual_precision {
  height: 18px;
  border : none;
  margin : 0;
  padding: 0;
}

.room-panel {
    display: flex;
    flex : 8 1;
    flex-direction: column;  
}

.chat-panel {
  overflow:hidden;

  flex: 3 1;
  display: flex;
  flex-direction: column;  
  flex-grow : 0;
}

.left-panel.hidden {
  width : 0;
  opacity : 0;
  flex-grow : 0;
}
.left-panel.visible {
  width : 98%;
  opacity : 1;
  flex-grow : 1;
}
.left-panel.visible.mobile {
  width : 90%;
  height : 94%;
  opacity : 1;
  flex-grow : 1;
}
.right-panel.hidden {
  width : 0;
  opacity : 0;
}
.right-panel.visible {
  width : 98%;
  opacity : 1;
  flex-grow : 1;
}

.right-panel.visible.mobile {
  width : 50%;
  height : 50%;
  opacity : 1;
  flex-grow : 1;
}

.chatrooms-list {
  float : left;
  width: 47.74%;
  height : 50%;
  background-color: #395e65;
  color : #fff066;
  padding: 2x;
  border-right: 1px solid #ccc;
}


.chatStatus{
  left : 0;
  width: 55%;
  height : 50%;
  background-color: #ebebeb;
  color : #131101;
  padding: 20px;
  border-right: 1px solid #090909;
}

.chat-panel {
  top: 0;
}

.tooltip_info {
  max-height : 150px;
  overflow-y: auto;
}

.mindmap_node_0{
  font-size : medium;
  text-align : start;
  stroke: rgb(213, 10, 10)
}
.mindmap_node_1{
  font-size : small;
  text-align : left;
  stroke: rgb(30, 15, 247)
}
.mindmap_node_2{
  font-size : smaller;  
  text-align : left;
  stroke: rgb(119, 119, 119)
}
.mindmap_node_3{
  font-size : smaller;
  text-align : left;
  stroke: rgb(30, 4, 62)
}

.chatrooms-list ul {
  list-style: none;
  padding: 0;
}

.logedInName {
  vertical-align: center;
  margin-bottom : 5px;
}

.logedInName2 {
  cursor: cell;
  color: #efffef;
}

.chronoValue {
  color: #efffef;
  margin: 2px;
}

.pauseValue {
  color: #efffef;
  font-size : 14px;
  margin-top: 0px;
}

.horizontal-carousel {
  display: flex;
  align-items: flex-end ;
  flex-wrap: nowrap;
  align-items: flex-end;
  justify-content: space-evenly;
  padding-left: 10px;
}

.horizontal-carousel-header {
  display: flex;
  height: 29px;
  justify-content: space-around;
  align-items: center;
  padding : 1px;
  margin: 0px;
  border-width: 0px;
}

.options-container {
  display: flex;
  overflow: hidden;
  width: 90%; /* Ajuster selon vos besoins */
  height : 50px;
  justify-content: center;
}


.roomlist_option {
  flex: 0 40 100px; /* Ajuster la largeur des options */
  transition: transform 0.3s, opacity 0.3s;
  background-color: #efffef
  ;
  border-radius: 2px;
  min-width: 77px;
  text-align: center;
  border: 2px solid #395e65;
  cursor: pointer;
  transform : scaley(0.7);
  margin : 2px;
  font-size: xx-small;
  box-shadow: 0 0 10px #395e65;
  transition: box-shadow 0.5s ease-in-out;
}


.roomlist_option.active {
  color: #395e65;
  background-color: #fff066;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);
  z-index: 1;
}


.horizontal-carousel-button {
  opacity : .6;
  padding-top: 5px;
  scale : .4;
  border-radius : 50%;
}

.chatrooms-list li , .bienvenue, button{
  cursor: default;
  padding: 5px;
  margin: 6px 0;
  color: #fff066;
  background-color :#395e65 ;
  border-radius: 4%;
}

.chatroom {
  cursor: default;
  padding: 1px;
  margin: 1px 0;
  color: #fff066;
  background-color :#395e65 ;
  border-radius: 4%;
}

roomlist_button {
  background-color: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

buttono {
  background-color: #04AA6D; /* Green */
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
}

.selfPastMessage {
  text-align : center;
  color : #395e65;
  background-color : #fff066;}

.pastMessage {
 text-align : left;
 background-color : #395e65;
 color : #fff066;
}

.help-messages {
  height : 10%;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: justify;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.username-form {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.username-form input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-right: 10px;
}

.username-form button {
  padding: 10px 20px;
  border: none;
  background: #395e65;
  color: #fff066;
  border-radius: 4px;
  cursor: pointer;
}

.mobile-tabs {
  display: flex;
  flex-direction: column;
  margin : 20px;
  height: 100vh;
}

.tab-buttons {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #ccc;
}

.tab-buttons button {
  background: #395e65;
  color: #fff066;
  border-radius: 4px;
  flex: 1 1;
  padding: 12px;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

.tab-button.active {
  opacity : 1;
}

.tab-button {
  opacity : .6;
}

.tab-content {
  flex: 1 1;
  flex-direction: column;
  overflow: auto;
  padding: 10px;
  height : 200%;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,UAAU;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAQ;EACR,gBAAgB;AAClB;;;;AAIA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,+BAA+B;EAC/B,2CAAkD;AACpD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,cAAc;EACd,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB;;AAEF;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,UAAU;AACZ;;AAEA;IACI,aAAa;IACb,UAAQ;IACR,sBAAsB;AAC1B;;AAEA;EACE,eAAe;;EAEf,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;AACf;AACA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,4BAA4B;AAC9B;;;AAGA;EACE,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB;AACF;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB;AACF;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB;AACF;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU,EAAE,8BAA8B;EAC1C,aAAa;EACb,uBAAuB;AACzB;;;AAGA;EACE,gBAAgB,EAAE,mCAAmC;EACrD,wCAAwC;EACxC;EACA;EACA,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,uCAAuC;AACzC;;;AAGA;EACE,cAAc;EACd,yBAAyB;EACzB,uCAAuC;EACvC,UAAU;AACZ;;;AAGA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,cAAc;EACd,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,UAAU;EACrC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,0BAA0B,CAAC;;AAE7B;CACC,iBAAiB;CACjB,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,aAAa;AACf","sourcesContent":["#root {\r\n  overflow: hidden;\r\n}\r\n\r\n.main_display {\r\n  display : flex;\r\n  /* height: -webkit-fill-available; */\r\n  height : 97vh;\r\n  background-color: #395e65;\r\n  overflow: hidden;\r\n}\r\n\r\n.no-select {\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n\r\n.main_page_frame {\r\n    display: -webkit-inline-box;\r\n    height: 100%;\r\n    width: 100%;\r\n    border : 0;\r\n}\r\n\r\n.logo_display {\r\n  display : flex;\r\n  cursor : help;\r\n  width : 500%;\r\n  height : 500%;\r\n}\r\n\r\n.image_display {\r\n  width : 100px;;\r\n  height : 115px;;\r\n}\r\n\r\n.main_page_index {\r\n  background-color: #395e65;\r\n  width : 85%;\r\n  align : \"center\";\r\n}\r\n\r\n.main_page_index.mobile {\r\n  width : 65%;\r\n}\r\n\r\n.App {\r\n  text-align: center;\r\n  flex : 1;\r\n  overflow: hidden;\r\n}\r\n\r\n\r\n\r\n.app_panel {\r\n  overflow: hidden;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n@font-face {\r\n  font-family: alte_haas_grotesk ;\r\n  src:url(\"../public/fonts/AlteHaasGroteskBold.ttf\");\r\n}\r\n\r\n* {\r\n  font-family: alte_haas_grotesk;\r\n}\r\n\r\n.chat-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 90vh; \r\n  overflow-y: hidden;\r\n}\r\n\r\n.chat-menus {\r\n  display : flex;\r\n  flex-direction: row;\r\n  height: 11%; \r\n}\r\n\r\n\r\n.chat-header {\r\n  display: flex;\r\n  width : 47%;\r\n  gap : 10px;\r\n  flex-direction: row;\r\n  height : 10%;\r\n}\r\n.chat-double-panel {\r\n  display : flex;\r\n  width : 98%;\r\n  gap : 1x;\r\n  height : 91%;\r\n  overflow-y: hidden;\r\n}\r\n\r\n.split-handle {\r\n  background-color: #fff066;\r\n  cursor: col-resize;\r\n  position: relative;\r\n  border-radius: 10px;\r\n  }\r\n\r\n.split-handle:hover,\r\n.split-handle:active {\r\n  background-color: #83ddef;\r\n}\r\n\r\n.graphContainer {\r\n  width: 165%;\r\n  height: 62%; \r\n}\r\n\r\n.semantic_panel {\r\n  overflow-y : hidden;\r\n}\r\n\r\n\r\n.graphContainer.mobile {\r\n  width: 130%;\r\n  height: 200%; \r\n}\r\n\r\n.qual_precision {\r\n  height: 18px;\r\n  border : none;\r\n  margin : 0;\r\n  padding: 0;\r\n}\r\n\r\n.room-panel {\r\n    display: flex;\r\n    flex : 8;\r\n    flex-direction: column;  \r\n}\r\n\r\n.chat-panel {\r\n  overflow:hidden;\r\n\r\n  flex: 3;\r\n  display: flex;\r\n  flex-direction: column;  \r\n  flex-grow : 0;\r\n}\r\n\r\n.left-panel.hidden {\r\n  width : 0;\r\n  opacity : 0;\r\n  flex-grow : 0;\r\n}\r\n.left-panel.visible {\r\n  width : 98%;\r\n  opacity : 1;\r\n  flex-grow : 1;\r\n}\r\n.left-panel.visible.mobile {\r\n  width : 90%;\r\n  height : 94%;\r\n  opacity : 1;\r\n  flex-grow : 1;\r\n}\r\n.right-panel.hidden {\r\n  width : 0;\r\n  opacity : 0;\r\n}\r\n.right-panel.visible {\r\n  width : 98%;\r\n  opacity : 1;\r\n  flex-grow : 1;\r\n}\r\n\r\n.right-panel.visible.mobile {\r\n  width : 50%;\r\n  height : 50%;\r\n  opacity : 1;\r\n  flex-grow : 1;\r\n}\r\n\r\n.chatrooms-list {\r\n  float : left;\r\n  width: 47.74%;\r\n  height : 50%;\r\n  background-color: #395e65;\r\n  color : #fff066;\r\n  padding: 2x;\r\n  border-right: 1px solid #ccc;\r\n}\r\n\r\n\r\n.chatStatus{\r\n  left : 0;\r\n  width: 55%;\r\n  height : 50%;\r\n  background-color: #ebebeb;\r\n  color : #131101;\r\n  padding: 20px;\r\n  border-right: 1px solid #090909;\r\n}\r\n\r\n.chat-panel {\r\n  top: 0;\r\n}\r\n\r\n.tooltip_info {\r\n  max-height : 150px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.mindmap_node_0{\r\n  font-size : medium;\r\n  text-align : start;\r\n  stroke: rgb(213, 10, 10)\r\n}\r\n.mindmap_node_1{\r\n  font-size : small;\r\n  text-align : left;\r\n  stroke: rgb(30, 15, 247)\r\n}\r\n.mindmap_node_2{\r\n  font-size : smaller;  \r\n  text-align : left;\r\n  stroke: rgb(119, 119, 119)\r\n}\r\n.mindmap_node_3{\r\n  font-size : smaller;\r\n  text-align : left;\r\n  stroke: rgb(30, 4, 62)\r\n}\r\n\r\n.chatrooms-list ul {\r\n  list-style: none;\r\n  padding: 0;\r\n}\r\n\r\n.logedInName {\r\n  vertical-align: center;\r\n  margin-bottom : 5px;\r\n}\r\n\r\n.logedInName2 {\r\n  cursor: cell;\r\n  color: #efffef;\r\n}\r\n\r\n.chronoValue {\r\n  color: #efffef;\r\n  margin: 2px;\r\n}\r\n\r\n.pauseValue {\r\n  color: #efffef;\r\n  font-size : 14px;\r\n  margin-top: 0px;\r\n}\r\n\r\n.horizontal-carousel {\r\n  display: flex;\r\n  align-items: flex-end ;\r\n  flex-wrap: nowrap;\r\n  align-items: flex-end;\r\n  justify-content: space-evenly;\r\n  padding-left: 10px;\r\n}\r\n\r\n.horizontal-carousel-header {\r\n  display: flex;\r\n  height: 29px;\r\n  justify-content: space-around;\r\n  align-items: center;\r\n  padding : 1px;\r\n  margin: 0px;\r\n  border-width: 0px;\r\n}\r\n\r\n.options-container {\r\n  display: flex;\r\n  overflow: hidden;\r\n  width: 90%; /* Ajuster selon vos besoins */\r\n  height : 50px;\r\n  justify-content: center;\r\n}\r\n\r\n\r\n.roomlist_option {\r\n  flex: 0 40 100px; /* Ajuster la largeur des options */\r\n  transition: transform 0.3s, opacity 0.3s;\r\n  background-color: #efffef\r\n  ;\r\n  border-radius: 2px;\r\n  min-width: 77px;\r\n  text-align: center;\r\n  border: 2px solid #395e65;\r\n  cursor: pointer;\r\n  transform : scaley(0.7);\r\n  margin : 2px;\r\n  font-size: xx-small;\r\n  box-shadow: 0 0 10px #395e65;\r\n  transition: box-shadow 0.5s ease-in-out;\r\n}\r\n\r\n\r\n.roomlist_option.active {\r\n  color: #395e65;\r\n  background-color: #fff066;\r\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.8);\r\n  z-index: 1;\r\n}\r\n\r\n\r\n.horizontal-carousel-button {\r\n  opacity : .6;\r\n  padding-top: 5px;\r\n  scale : .4;\r\n  border-radius : 50%;\r\n}\r\n\r\n.chatrooms-list li , .bienvenue, button{\r\n  cursor: default;\r\n  padding: 5px;\r\n  margin: 6px 0;\r\n  color: #fff066;\r\n  background-color :#395e65 ;\r\n  border-radius: 4%;\r\n}\r\n\r\n.chatroom {\r\n  cursor: default;\r\n  padding: 1px;\r\n  margin: 1px 0;\r\n  color: #fff066;\r\n  background-color :#395e65 ;\r\n  border-radius: 4%;\r\n}\r\n\r\nroomlist_button {\r\n  background-color: transparent;\r\n  border: none;\r\n  font-size: 20px;\r\n  cursor: pointer;\r\n}\r\n\r\nbuttono {\r\n  background-color: #04AA6D; /* Green */\r\n  border: none;\r\n  color: white;\r\n  padding: 15px 32px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  display: inline-block;\r\n  font-size: 16px;\r\n}\r\n\r\n.selfPastMessage {\r\n  text-align : center;\r\n  color : #395e65;\r\n  background-color : #fff066;}\r\n\r\n.pastMessage {\r\n text-align : left;\r\n background-color : #395e65;\r\n color : #fff066;\r\n}\r\n\r\n.help-messages {\r\n  height : 10%;\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  text-align: justify;\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.username-form {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n}\r\n\r\n.username-form input {\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  margin-right: 10px;\r\n}\r\n\r\n.username-form button {\r\n  padding: 10px 20px;\r\n  border: none;\r\n  background: #395e65;\r\n  color: #fff066;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.mobile-tabs {\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin : 20px;\r\n  height: 100vh;\r\n}\r\n\r\n.tab-buttons {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.tab-buttons button {\r\n  background: #395e65;\r\n  color: #fff066;\r\n  border-radius: 4px;\r\n  flex: 1;\r\n  padding: 12px;\r\n  border: none;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n}\r\n\r\n.tab-button.active {\r\n  opacity : 1;\r\n}\r\n\r\n.tab-button {\r\n  opacity : .6;\r\n}\r\n\r\n.tab-content {\r\n  flex: 1;\r\n  flex-direction: column;\r\n  overflow: auto;\r\n  padding: 10px;\r\n  height : 200%;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
